import {SWF_FORM_PREFIX} from './constants';

const IGNORED_FIELD_NAMES = [
    'cf-turnstile-response',
    'g-recaptcha-response',
];

export const fileAttachmentFieldNameAttribute = 'data-swf-file-field-name';

const FILE_ATTACHMENT_VALUE_SELECTOR = 'input[data-swf-file-attachment-value][name]';

const appendFieldValue = (fields, name, value) => {
  if (Object.prototype.hasOwnProperty.call(fields, name)) {
    fields[name] = Array.isArray(fields[name]) ? [...fields[name], value] : [fields[name], value];
  } else {
    fields[name] = value;
  }
};

export const formFieldsWithRepeatedValues = (fields, formElement) => {
  if (!formElement?.querySelectorAll) {
    return fields;
  }

  const repeatedFields = [...formElement.querySelectorAll(FILE_ATTACHMENT_VALUE_SELECTOR)]
      .filter(input => input.name && !input.disabled)
      .reduce((values, input) => {
        appendFieldValue(values, input.name, input.value ?? '');
        return values;
      }, {});

  return Object.keys(repeatedFields).length === 0
      ? fields
      : {
        ...fields,
        ...repeatedFields,
      };
};

export const filterFields = fields => Object.keys(fields).
filter(key =>
    !(key.startsWith('_') ||
        key.startsWith('swf:') ||
        key.startsWith('jsonata:') ||
        IGNORED_FIELD_NAMES.includes(key))).
reduce((obj, key) => {
  obj[key.replace(SWF_FORM_PREFIX, '')] = fields[key];
  return obj;
}, {});
